import { useState, useEffect } from "react"
import axiosWithAuth from "../../utils/axiosWithAuth"
import * as yup from "yup"
import schema from "../validation/formSchemaManagerEdit"

import "../../styles/ManagerRegister.css"

import { toast } from "react-toastify"
import 'react-toastify/dist/ReactToastify.css';
toast.configure()

const initialEditForm = {
  role: 2,
  email: "",
  phone: "",
  password: "",
  password_confirm: ""
}

const initialFormErrors = {
  role: "",
  email: "",
  phone: "",
  password: "",
  password_confirm: ""
}

function ManagerEditForm() {
  const [ curEmail, setCurEmail ] = useState("")
  const [ emailList, setEmailList ] = useState([])
  const [ editForm, setEditForm ] = useState(initialEditForm)
  const [ formErrors, setFormErrors ] = useState(initialFormErrors)
  const [ disabled, setDisabled ] = useState(true)

  useEffect(() => {
    axiosWithAuth().get("/user/admins")
      .then(res => {
        setEmailList(res.data.map(item => { return item.email }))
      })
  }, [])

  const handleEmailChange = e => {
    setEditForm({...editForm,
      email: e.target.value
    })
    return setCurEmail(e.target.value)
  }

  const handleEditChange = e => {
    const {name, value} = e.target
    yup
      .reach(schema, name)
      .validate(value)
      .then(() => {
        setFormErrors({
          ...formErrors,
          [name]: ""
        })
      })
      .catch(err => {
        setFormErrors({
          ...formErrors,
          [name]: err.errors[0]
        })
      })

    setEditForm({
      ...editForm,
      [e.target.name]: e.target.value
    })
  }

  const handleEditSubmit = e => {
    e.preventDefault()
    let updatedUser = {
      role: editForm.role,
      email: curEmail,
      phone: editForm.phone,
      password: editForm.password
    }

    axiosWithAuth().put("/auth/update", updatedUser)
      .then(() => {
        toast(`Update Success`)
        return setCurEmail("")
      })
      .catch(() => {
        toast(`Something went wrong`)
      })
  }

  useEffect(() => {
    schema.isValid(editForm).then(valid => {
      setDisabled(!valid)
    })
  }, [editForm])

  return (
    <div className="msu-container">
      <div className="msu-form">
        <select className="msu-input" type="dropdown" onChange={handleEmailChange}>
          <option value="">- Select an email -</option>
          {emailList.length > 0 ?
            emailList.map(item => {
              return <option value={item} key={item}>{item}</option>
            })
          : null}
        </select>
      </div>

      {curEmail ?
        <div className="mu-submit-container">
          <form onSubmit={handleEditSubmit} className="msu-form">
            {editForm.role ?
              <span className="su-errors">{formErrors.role}</span>
            : null}
            <select name="role" type="dropdown" className="msu-input" onChange={handleEditChange}>
              <option value={2}>Manager</option>
              <option value={3}>Administrator</option>
            </select>

            {editForm.email ?
              <span className="su-errors">{formErrors.email}</span>
            : null}
            <input
              readOnly
              className="msu-input"
              type="text" 
              name="email" 
              placeholder="Email" 
              value={curEmail}
            />

            {editForm.phone ?
              <span className="su-errors">{formErrors.phone}</span>
            : null}
            <input 
              className="msu-input"
              type="phone" 
              name="phone" 
              placeholder="Phone # (optional)" 
              onChange={handleEditChange} 
              value={editForm.phone} 
            />

            {editForm.password ?
              <span className="su-errors">{formErrors.password}</span>
            : null}
            <input 
              className="msu-input"
              type="password" 
              name="password" 
              placeholder="Password" 
              onChange={handleEditChange} 
              value={editForm.password} 
            />
            
            {editForm.password_confirm ?
              <span className="su-errors">{formErrors.password_confirm}</span>
            : null}
            {editForm.password_confirm ?
              editForm.password_confirm !== editForm.password ?
                <span className="su-errors">*Passwords must match</span>
              : null
            : null}
            <input 
              className="msu-input"
              type="password" 
              name="password_confirm" 
              placeholder="Confirm Password" 
              onChange={handleEditChange} 
              value={editForm.password_confirm} 
            />
          
            <div className="mu-submit-button-container">
              {editForm.password_confirm ?
                editForm.password_confirm === editForm.password ?
                  <button disabled={disabled} onClick={handleEditSubmit} className="ad-tool">Edit</button>
                : <button disabled={true} className="ad-tool">Edit</button>
              : <button disabled={true} className="ad-tool">Edit</button>}
            </div>
          </form>
        </div>
      : null}
      
    </div>
  )
}

export default ManagerEditForm
